import { render, staticRenderFns } from "./JudgementWaiterTab.vue?vue&type=template&id=318674ae&scoped=true&lang=pug"
import script from "./JudgementWaiterTab.vue?vue&type=script&lang=ts"
export * from "./JudgementWaiterTab.vue?vue&type=script&lang=ts"
import style0 from "./JudgementWaiterTab.vue?vue&type=style&index=0&id=318674ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318674ae",
  null
  
)

export default component.exports